import { useEffect, useRef, useState } from "react";
import { parseLocalDateTime } from "../utils/parseLocalDateTime";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useEventManagerContext } from "../context/eventContext";

export default function useEventLock() {
  const { isAStudent, isATeacher, isStudentView, isTeacherView } =
    useAppContext();
  const { selectedEvent, isAnEventManagerAdmin } = useEventManagerContext();

  const [now, setNow] = useState(new Date());
  const [showUnlockedToast, setShowUnlockedToast] = useState(false);

  const unlockTime = parseLocalDateTime(selectedEvent?.unlockTime);

  /**
   * ✅ update time when event changes
   */
  useEffect(() => {
    setNow(new Date());
  }, [selectedEvent?.id, selectedEvent?.unlockTime]);

  /**
   * ✅ schedule unlock (ONLY based on time)
   */
  useEffect(() => {
    if (!unlockTime) return;

    const current = new Date();
    if (current >= unlockTime) return;

    const timeout = setTimeout(() => {
      setNow(new Date());
    }, unlockTime - current);

    return () => clearTimeout(timeout);
  }, [unlockTime]);

  /**
   * ✅ role-based lock decision
   */
  const shouldBeLocked =
    (isAStudent && selectedEvent?.lockForStudents) ||
    (isATeacher &&
      selectedEvent?.lockForTeachers &&
      (!isAnEventManagerAdmin || isStudentView || isTeacherView));

  /**
   * ✅ final lock state
   */
  const showLockScreen = shouldBeLocked && unlockTime && now < unlockTime;

  /**
   * ✅ toast (locked → unlocked)
   */
  const prevLockedRef = useRef(showLockScreen);

  useEffect(() => {
    if (prevLockedRef.current && !showLockScreen) {
      setShowUnlockedToast(true);
    }
    prevLockedRef.current = showLockScreen;
  }, [showLockScreen]);

  return {
    showLockScreen,
    unlockTime,
    showUnlockedToast,
    setShowUnlockedToast,
  };
}
